var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.042 40.9H2.002C.896 40.9 0 41.816 0 42.946s.896 2.044 2.002 2.044h40.04c1.105 0 2.002-.915 2.002-2.044-.001-1.13-.897-2.046-2.002-2.046zM4.505 35.584c-1.107 0-2.003.915-2.003 2.045s.896 2.046 2.003 2.046h35.034c1.106 0 2.003-.917 2.003-2.046 0-1.13-.897-2.045-2.003-2.045h-.5V17.18h.5c.554 0 1-.457 1-1.021 0-.564-.448-1.022-1-1.022H4.505c-.553 0-1 .458-1 1.022 0 .564.448 1.021 1 1.021h.5v18.402h-.5zm30.53-18.403v18.402h-6.006V17.18h6.005zm-10.011 0v18.402h-6.006V17.18h6.006zm-16.016 0h6.006v18.402H9.008V17.18zM2.002 13.3h40.059c1.107 0 2.002-.915 2.002-2.045 0-.898-.566-1.66-1.352-1.935L22.845.19a1.968 1.968 0 0 0-1.642 0L1.18 9.39a2.056 2.056 0 0 0-1.136 2.295A2.012 2.012 0 0 0 2.003 13.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon_building.c506afa01bae87a1987a06e60b336917.svg";
export { ForwardRef as ReactComponent };